import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=2f2081c0&scoped=true&lang=pug&"
var script = {}
import style0 from "./Status.vue?vue&type=style&index=0&id=2f2081c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2081c0",
  null
  
)

export default component.exports